"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTezModule = void 0;
require("isomorphic-fetch");
var AbstractTezModule = /** @class */ (function () {
    function AbstractTezModule(provider, chain, debugMode) {
        var _this = this;
        if (debugMode === void 0) { debugMode = false; }
        /**
         * @description Queries a node given a path and payload
         * @param {string} path The RPC path to query
         * @param {string} [payload] The payload of the query
         * @param {string} [method] The request method. Either 'GET' or 'POST'
         * @returns {Promise} The response of the query
         * @example
         * sotez.query(`/chains/main/blocks/head`)
         *  .then(head => console.log(head));
         */
        this.query = function (path, payload, method) {
            var queryMethod = method;
            var queryPayload = payload;
            if (!queryPayload) {
                if (!queryMethod) {
                    queryMethod = 'GET';
                }
                else {
                    queryPayload = {};
                }
            }
            else if (!queryMethod) {
                queryMethod = 'POST';
            }
            if (_this._debugMode) {
                console.log('Query Request:', path, payload);
            }
            return new Promise(function (resolve, reject) {
                fetch("" + _this.provider + path, {
                    method: queryMethod,
                    headers: __assign({}, (queryMethod === 'POST'
                        ? { 'Content-Type': 'application/json' }
                        : {})),
                    body: JSON.stringify(queryPayload),
                })
                    .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                    var contentType, isJson;
                    return __generator(this, function (_a) {
                        if (this._debugMode) {
                            console.log('Query Response:', path, response);
                        }
                        contentType = response.headers.get('content-type');
                        isJson = contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json');
                        if (!response.ok) {
                            if (isJson) {
                                return [2 /*return*/, response.json().then(reject)];
                            }
                            return [2 /*return*/, response.text().then(reject)];
                        }
                        if (isJson) {
                            return [2 /*return*/, response.json().then(resolve)];
                        }
                        return [2 /*return*/, response.text().then(resolve)];
                    });
                }); })
                    .catch(reject);
            });
        };
        this._provider = provider;
        this._chain = chain;
        this._debugMode = debugMode;
    }
    Object.defineProperty(AbstractTezModule.prototype, "provider", {
        get: function () {
            return this._provider;
        },
        set: function (provider) {
            this._provider = provider;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractTezModule.prototype, "chain", {
        get: function () {
            return this._chain;
        },
        set: function (value) {
            this._chain = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractTezModule.prototype, "debugMode", {
        get: function () {
            return this._debugMode;
        },
        set: function (value) {
            this._debugMode = value;
        },
        enumerable: false,
        configurable: true
    });
    AbstractTezModule.prototype.setProvider = function (provider, chain) {
        if (chain === void 0) { chain = this.chain; }
        this._provider = provider;
        this._chain = chain;
    };
    return AbstractTezModule;
}());
exports.AbstractTezModule = AbstractTezModule;
